// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".parent_Box[data-v-e8a4568c] {\n  position: absolute;\n  top: 80px;\n  right: 0px;\n  width: calc((100% - (20px * 1)) / 2);\n}", ""]);
// Exports
module.exports = exports;
